import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import SouthIcon from "@mui/icons-material/South";

import { SessionSummary } from "../../DashboardView/components/RescheduleDialog";
import { formatMoney } from "../../DashboardView/dashboardHelpers";

// A wall date + time as the fake-UTC stamp SessionSummary reads.
const wallStamp = (date, time) => `${date}T${time}:00.000Z`;

function CourtRescheduleDialog({ reschedule, currency, isMobile }) {
  const { target, info, submitting } = reschedule;
  const from = info?.from;

  return (
    <Dialog open={!!target} onClose={reschedule.close} maxWidth="sm" fullWidth fullScreen={isMobile}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, pr: 1.5 }}>
        Confirm new time
        <IconButton onClick={reschedule.close} disabled={submitting} aria-label="Close">
          <CloseIcon sx={{ fontSize: "1.25rem" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {target && from && (
          <Box>
            <SessionSummary
              label="From"
              startDate={wallStamp(from.date, from.time)}
              time={from.time}
              duration={from.duration}
              facilityName={from.facilityName}
              locationName={from.locationName}
            />
            <Box display="flex" justifyContent="center" py={0.5}>
              <SouthIcon sx={{ fontSize: "1.25rem", color: "text.secondary" }} />
            </Box>
            <Box mb={2}>
              <SessionSummary
                label="To"
                startDate={wallStamp(target.date, target.slot.time)}
                time={target.slot.time}
                duration={target.slot.duration}
                facilityName={target.slot.facilityName}
                locationName={target.slot.locationName}
                highlight
              />
            </Box>

            <Alert severity="success" variant="outlined">
              The {formatMoney(info.creditAmount, currency)} you paid moves with you. There's nothing to pay.
            </Alert>

            <Typography variant="body2" color="textSecondary" mt={2}>
              Your current booking is cancelled only once the new time is confirmed.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={reschedule.close} disabled={submitting}>
          Back
        </Button>
        <Button variant="contained" onClick={reschedule.confirm} disabled={submitting} sx={{ color: "common.white" }}>
          {submitting ? <CircularProgress size={18} /> : "Confirm move"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CourtRescheduleDialog;
